import { useTranslation } from "react-i18next";
import {
  STORYTELLING_HEADER_META_KEYS,
  getStorytellingHeaderMetaDefaults,
} from "./storytellingHeaderMeta";

const FIELD_TITLE_KEYS = {
  city: "storytellingHeaderCityTitle",
  founded: "storytellingHeaderFoundedTitle",
  type: "storytellingHeaderTypeTitle",
  cuisine: "storytellingHeaderCuisineTitle",
};

function StorytellingHeaderMetaSection({
  rawHeaderMeta,
  updateHeaderMeta,
  restaurantData,
}) {
  const { t } = useTranslation();
  const defaults = getStorytellingHeaderMetaDefaults(restaurantData || {}, t);

  return (
    <div className="storytelling-header-meta-section">
      <h5 className="storytelling-stepper__control-title">
        {t("storytellingHeaderMetaTitle")}
      </h5>
      <p className="text-muted small mb-3">{t("storytellingHeaderMetaHint")}</p>

      <div className="storytelling-header-meta-section__grid">
        {STORYTELLING_HEADER_META_KEYS.map((key) => {
          const field = rawHeaderMeta?.[key] || { show: true, label: "", value: "" };
          const defaultField = defaults[key];

          return (
            <div className="storytelling-header-meta-section__card" key={key}>
              <div className="storytelling-header-meta-section__card-header">
                <strong>{t(FIELD_TITLE_KEYS[key])}</strong>
                <div className="form-check form-switch mb-0">
                  <input
                    className="form-check-input"
                    type="checkbox"
                    id={`storytelling-header-${key}-show`}
                    checked={field.show}
                    onChange={(e) => updateHeaderMeta(key, "show", e.target.checked)}
                  />
                  <label
                    className="form-check-label"
                    htmlFor={`storytelling-header-${key}-show`}
                  >
                    {t("storytellingHeaderShowField")}
                  </label>
                </div>
              </div>

              <div className="mb-2">
                <label
                  className="form-label text-primary"
                  htmlFor={`storytelling-header-${key}-label`}
                >
                  {t("storytellingHeaderFieldLabel")}
                </label>
                <input
                  id={`storytelling-header-${key}-label`}
                  type="text"
                  className="form-control"
                  value={field.label}
                  placeholder={defaultField.label}
                  onChange={(e) => updateHeaderMeta(key, "label", e.target.value)}
                />
              </div>

              <div>
                <label
                  className="form-label text-primary"
                  htmlFor={`storytelling-header-${key}-value`}
                >
                  {t("storytellingHeaderFieldValue")}
                </label>
                <input
                  id={`storytelling-header-${key}-value`}
                  type="text"
                  className="form-control"
                  value={field.value}
                  placeholder={defaultField.value || t("storytellingHeaderFieldValuePlaceholder")}
                  onChange={(e) => updateHeaderMeta(key, "value", e.target.value)}
                />
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
}

export default StorytellingHeaderMetaSection;
